module.exports = __webpack_public_path__ + "img/pup23.810b297f.jpg";